import { U21RuleSearch } from 'app/shared/u21-ui/components/dashboard/U21RuleSearch';

interface OwnProps {
  onChange: (value: number[]) => void;
  value: number[];
}

export const RulesFilters = ({ onChange, value }: OwnProps) => {
  return (
    <U21RuleSearch
      onChange={onChange}
      value={value}
      autoFocus
      backdrop
      clearable={false}
      label={undefined}
      multi
    />
  );
};
